import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Sessions } from 'src/app/libraries/sessions';
import { IReturn } from 'src/app/libraries/ireturn';
import { APP_BASE_HREF } from '@angular/common';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CapacitacionesTiposService {

  constructor(private http: HttpClient,  @Inject(APP_BASE_HREF) private baseUrl: string) { }

  index(): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Tipos/Index", null, Sessions.header());
  }

  dataSource(varArgs : any = null): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Tipos/DataSource", varArgs, Sessions.header());
  }

  create(): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Tipos/Create", null, Sessions.header());
  }

  store(objCapacitacionTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Tipos/Store", objCapacitacionTipo, Sessions.header());
  }

  edit(objCapacitacionTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Tipos/Edit", objCapacitacionTipo, Sessions.header());
  }

  update(objCapacitacionTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Tipos/Update", objCapacitacionTipo, Sessions.header());
  }

  delete(objCapacitacionTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Tipos/Delete", objCapacitacionTipo, Sessions.header());
  }

  listByIdCapacitacionGrupo(objCapacitacionTipo : any): Observable<IReturn> {
    return this.http.post<IReturn>(this.baseUrl + "api/Capacitaciones/Tipos/ListByIdCapacitacionGrupo", objCapacitacionTipo, Sessions.header());
  }

}